import React from 'react';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';

const QuotesNullView = () => {
  const { imageAlt, imageUrl } = fallbackViewTexts;

  return (
    <div className="sui-@container sui-h-full">
      <div className="sui-block @sm:sui-hidden sui-h-full">
        <CompactNullView
          imageUrl={imageUrl}
          imageAlt={imageAlt}
        />
      </div>
      <div className="sui-hidden @sm:sui-block sui-h-full">
        <DesktopNullView
          imageUrl={imageUrl}
          imageAlt={imageAlt}
        />
      </div>
    </div>
  );
};

QuotesNullView.propTypes = {};
QuotesNullView.defaultProps = {};

export default QuotesNullView;
